import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

/**
 * Clase que maneja dialog abierto desde dialog-utils.service.ts.
 * Recibe los datos a mostrar en el dialog e implementa
 * la funcionalidad de sus botones
 *
 */
@Component({
  selector: "i3tel-dialgo-utils",
  templateUrl: "./dialog-utils.component.html",
  styleUrls: ["./dialog-utils.component.scss"],
})
export class DialogUtilsComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogUtilsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.dialogRef.addPanelClass(this.data.panelClass ? this.data.panelClass : '');
  }

  accionSuccess() {
    if (this.data.success != null) {
      const funcion = (callback) => {
        this.dialogRef.close();
        callback();
      };
      this.dialogRef.close();
      funcion(this.data.success);
    } else {
      this.dialogRef.close();
    }
  }

  accionReject() {
    if (this.data.reject != null) {
      const funcion = (callback) => {
        this.dialogRef.close();
        callback();
      };
      this.dialogRef.close();
      funcion(this.data.reject);
    } else {
      this.dialogRef.close();
    }
  }
}
